/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module CollectionsModule
 */

import { Collection } from 'ajs/modules/data-model/factories/collection.factory';
import { AviPermissionResource } from 'generated-types';
import { ControllerSite } from 'object-types';
import { ControllerSiteItem } from 'items/controller-site.item.factory';

/**
 * @description Controller Site Collection.
 * @author alextsg
 */
export class ControllerSiteCollection extends Collection {
    public static ngDependencies = [ControllerSiteItem];

    constructor(args = {}) {
        const extendedArgs = {
            objectName: 'controllersite',
            objectType: ControllerSite,
            permissionName: AviPermissionResource.PERMISSION_CONTROLLERSITE,
            ...args,
        };

        super(extendedArgs);

        this.itemClass_ = this.getNgDependency(ControllerSiteItem);
    }
}

export type TControllerSiteCollection = typeof ControllerSiteCollection;
